/**
 * The LINK_cybersource detail.js module only exports a single function
 * rather than extending its base module, and the two are executed one after the other.
 *
 * This cannot work with the dependency chain plugin, since any requests that resolve
 * to the base detail.js will result in the LINK_cybersource module instead,
 * leading to the base code being lost and only the LINK_cybersource function being executed.
 *
 * This is why this module does what the LINK_cybersource module should have done in the first place,
 * merging the two modules and resolving any requires to the top-level one with the merge result.
 *
 * CommonJS needs to be used instead of ES6 modules, since this needs to work in tandem with the base
 */
import $ from 'jquery';
import base from '~base/~base';
import baseInitApplePayButton from '~base';

base.initApplePayButton = () => {
  baseInitApplePayButton();

  $('body').on('product:updateAddToCart', (e, response) => {
    setTimeout(() => { // Execute after the base handler
      const applePayButton = response.$productContainer[0].querySelector('.apple-pay-pdp');

      if (applePayButton && !response.product.enableApplePayOnPDP) {
        applePayButton.remove();
      }
    }, 1);
  });
};

export default base;
